// src/features/payment/hooks/usePaymentCalculations.ts
import { useMemo } from "react";
import { CustomerData, Product } from "../types/payment";

export const usePaymentCalculations = (products: Product[], customer: CustomerData | null, showBalance: boolean, receivedAmount: number) => {
  return useMemo(() => {
    const orderAmount = products.reduce((sum, item) => sum + parseFloat(item.totalAmount), 0);

    const discount = products.reduce((sum, item) => sum + parseFloat(item.discount || "0"), 0);

    const deliveryFee = products.length > 0 ? Number(products[0].deliveryFee || 0) : 0;


    const finalAmount = orderAmount - discount + deliveryFee;
    const outstandingBalance = parseFloat(customer?.total_outstanding_balance || "0");
    const totalPayable = showBalance ? finalAmount + outstandingBalance : finalAmount;
    const remainingAmount = Math.max(totalPayable - receivedAmount, 0);

    return {
      orderAmount,
      discount,
      deliveryFee,
      finalAmount,
      outstandingBalance,
      totalPayable,
      remainingAmount,
    };
  }, [products, customer, showBalance, receivedAmount]);
};
